module.exports = __webpack_public_path__ + "media/site_templates/www.furnituredisposal.com.au/images/our_services_1-05d9c11c71958946df7de55fdaaaf3ed.jpg";